<template>
  <template v-if="canDropToTop">
    <ChecklistTableDroppableArea
      as="div"
      class="checklist-prepend-section"
      data-locator="checklist-preprend-sections"
      variant="after-section"
      @mouseUpDrop="onDropToTop"
    >
      <div class="drop-area" :class="{ 'droppable': isDraggingSection }"></div>
    </ChecklistTableDroppableArea>
  </template>

    <ChecklistTableSection :section="section" />

  <template v-if="canDropAfter">
    <ChecklistTableDroppableArea
      as="div"
      class="checklist-append-section"
      data-locator="checklist-append-sections"
      variant="after-section"
      @mouseUpDrop="onDropAfter"
    >
      <div class="drop-area" :class="{ 'droppable': isDraggingSection }"></div>
    </ChecklistTableDroppableArea>
  </template>
</template>

<script lang="ts">
  import { defineComponent, PropType } from 'vue'
  import { mapGetters, mapState } from 'vuex' 

  import ChecklistTableDroppableArea from '@/project/checklist/table/ChecklistTableDroppableArea.vue'
  import ChecklistTableSection from '@/project/checklist/table/ChecklistTableSection.vue'
  import { ChecklistSection } from '@/project/checklist/types'
  export default defineComponent({
    name: 'ChecklistTableDroppableSection',
    props: {
      checklistModel: {
        type: Array as PropType<ChecklistSection[]>,
        required: true,
      },
      section: {
        type: Object as PropType<ChecklistSection>,
        required: true,
      },
    },
    emits: ['drop-after', 'drop-to-top'],
    components: {
      ChecklistTableDroppableArea,
      ChecklistTableSection,
    },
    computed: {
      ...mapState('checklist', ['checklistDragItem']),
      ...mapGetters('checklist', [ 'isDraggingSection']),
      canDropAfter () {
        if(!this.isDraggingSection) return false

        const dropSectionBelowItself = this.isDraggingSection && this.checklistDragItem?.id === this.section.id
        const dropSectionAboveItself = this.isDraggingSection && this.checklistDragItem?.positionDisplay == Number(this.section.positionDisplay) + 1
        const dropLastSectionToTheBottom = this.isDraggingLastSection && this.section.id === this.checklistModel[this.checklistModel.length - 1].id

        if (dropSectionBelowItself || dropSectionAboveItself || dropLastSectionToTheBottom) {
          return false
        }

        return true
      },
      canDropToTop () {
        return this.isFirstSection && !this.isDraggingFirstSection
      },
      isDraggingFirstSection () {
        return this.checklistDragItem?.id === this.checklistModel[0].id
      },
      isDraggingLastSection () {
        return this.checklistDragItem?.id === this.checklistModel[this.checklistModel.length - 1].id
      },
      isFirstSection () {
        return this.section.id === this.checklistModel[0].id
      },
    },
    methods: {
      onDropAfter() {
        this.$emit('drop-after', this.section)
      },
      onDropToTop() {
        this.$emit('drop-to-top')
      },
    },
  })
</script>

<style scoped lang="scss">
  .checklist-section {
    background-color: inherit;
    display: grid;
    grid-template-columns: subgrid;
    grid-column: row-start / row-end;
  }
  
  .checklist-append-section,
  .checklist-prepend-section {
    grid-column: row-start / row-end;
    border-radius: 4px !important;

    .drop-area {
      height: 0;
      transition: height 0.2s ease-in-out;

      &.droppable {
        height: 12px
      }
    }
  }
</style>